import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  HostListener,
  Injector,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import { Link, StickyNavbarModule } from '@com-delta-idp/mnx-ui-kit';
import { Size, WindowUtilsService } from '@com-delta-idp/mnx-utils';
import { setAdobeAnalytics } from '../../utils/adobe-analytics.utils';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SectionComponent } from './components/section/section.component';
import { MenuHelpercomponent } from './menu-helper.component';
import { Menu, SCREEN_WIDTH, Section } from './models/menu.interfaces';
@Component({
  selector: 'idp-menu',
  standalone: true,
  imports: [StickyNavbarModule, NavbarComponent, SectionComponent, NgIf, NgFor],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent
  extends MenuHelpercomponent
  implements OnInit, OnChanges
{
  @Input() content: Menu = {} as Menu;
  @Input() accessToken = '';

  constructor(
    private utils: WindowUtilsService,
    private router: Router,
    protected override injector: Injector,
    private sessionService: SessionService
  ) {
    super(injector);
  }

  @HostListener('window:resize', ['$event'])
  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.sections = this.cloneSections(changes);
    this.setCurrentValues();
  }

  setCurrentValues() {
    this.content.sections.forEach((section) => {
      section.items.forEach((item) => {
        if (item.selected) {
          const { url, label } = { ...item.link };
          this.current = this.updateCurrentValues(
            url,
            label,
            window.innerWidth >= SCREEN_WIDTH.MOBILE
          );
        }
      });
    });
  }

  validateDevice() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      const resolution: Size = this.utils.getScreenResolution();
      this.height = this.screenHeight(resolution.width, resolution.height, 64);
    } else {
      this.height = this.screenHeight(
        window.innerWidth,
        window.innerHeight,
        133
      );
    }
  }

  init() {
    this.current.toggle = this.onResize();
    this.validateDevice();
  }

  cloneSections(changes: SimpleChanges): Section[] {
    if (
      changes['content'].currentValue &&
      changes['content'].currentValue.sections.length
    ) {
      return JSON.parse(
        JSON.stringify(changes['content'].currentValue.sections)
      );
    }
    return [];
  }

  updateLabelAndUrl(link: Link) {
    const current = this._getMatchingItemId(link.label);
    this.current = this.updateCurrentValues(
      link.url,
      link.label,
      window.innerWidth >= SCREEN_WIDTH.MOBILE
    );
    setAdobeAnalytics(
      this.getMenuEvent(
        link,
        current.sectionTitle,
        !!this.sessionService?.token?.access_token || !!this.accessToken
      )
    );
    this.redirectIfUrlOnPrem(link);
    this._routeExists(current.foundId)
      ? this.router.navigate([current.foundId])
      : window.open(link.url, '_self');
  }

  private _getMatchingItemId(label: string): {
    foundId: string;
    sectionTitle: string;
  } {
    let foundId = '';
    let sectionTitle = '';
    this.sections.forEach((section) => {
      section.items.forEach((item) => {
        item.selected = false;
        if (item.link.label.toLowerCase() === label.toLowerCase()) {
          item.selected = true;
          foundId = item.id;
          sectionTitle = section.title;
        }
      });
    });
    return { foundId, sectionTitle };
  }

  private _routeExists(route: string): boolean {
    return this.router.config.some((r) => r.path === route);
  }
}
